var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddMappingPlusIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5092_9517)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.34306 3.15617C5.76339 3.15617 2.86149 6.05807 2.86149 9.63774C2.86149 13.2174 5.76339 16.1193 9.34306 16.1193C12.9227 16.1193 15.8246 13.2174 15.8246 9.63774C15.8246 6.05807 12.9227 3.15617 9.34306 3.15617ZM1.42114 9.63774C1.42114 5.26258 4.96791 1.71582 9.34306 1.71582C13.7182 1.71582 17.265 5.26258 17.265 9.63774C17.265 14.0129 13.7182 17.5597 9.34306 17.5597C4.96791 17.5597 1.42114 14.0129 1.42114 9.63774Z",
    fill: "#111D31"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.34298 6.03711C9.74072 6.03711 10.0632 6.35954 10.0632 6.75728V12.5187C10.0632 12.9164 9.74072 13.2389 9.34298 13.2389C8.94524 13.2389 8.6228 12.9164 8.6228 12.5187V6.75728C8.6228 6.35954 8.94524 6.03711 9.34298 6.03711Z",
    fill: "#111D31"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.74219 9.63814C5.74219 9.2404 6.06462 8.91797 6.46236 8.91797H12.2238C12.6215 8.91797 12.9439 9.2404 12.9439 9.63814C12.9439 10.0359 12.6215 10.3583 12.2238 10.3583H6.46236C6.06462 10.3583 5.74219 10.0359 5.74219 9.63814Z",
    fill: "#111D31"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5092_9517"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.2842,
    height: 17.2842,
    fill: "white",
    transform: "translate(0.700928 0.996094)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddMappingPlusIcon);
export default __webpack_public_path__ + "static/media/AddMappingPlusIcon.5a1b8f806f5afea0337d796e644fb271.svg";
export { ForwardRef as ReactComponent };